import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="#08311d"
					image={require('./image.png')}
					title={"Combining UX and UI to Create Converting Websites"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on 11 May 2020  //  Posted in <strong>Web Development</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
								<h3>A successful <a href="https://www.moshi.com.au/website-development">website</a> that generates a high conversion rate (actions) from its users will always have a harmonious synergy between UX and UI, to create a smooth user path.</h3>

								</div>


<h2>What is UX?</h2> 
<p><b>UX</b> ‘User Experience’, is a human focused way of designing - it considers the user journey before anything else, to make a cohesive, natural flow for the user to follow. </p>

<p> UX encompasses factors such as the user’s perception of the brand, if they have any attitudes attached to the product or market, and how they are predicted to move through the site. </p>

<p>For example, a logical response to a website that requires a login is to have a ‘log in’ or ‘sign in’ popup upon entering the site. From there, a user can either log in, sign up, or recover their password. This image from <a href="https://www.uxplanet.org"> UX Planet</a> shows the typical user path.</p>

<img src={require('./image.png')} alt="UX in Play" height="200" width="650" className="align-centre" align="centre" />

<p>Actions such as these are commonplace, but as the understanding of user paths grows, so does the potential of making actions clearer and even more simple.</p>  

<br></br><hr></hr>

<h2>Understanding UI</h2> 
<p><b>UI</b> (User Interface), is similar to UX in that it is human centred design. The user interface considers the look and feel of the website experience, as well as how the user will interact with the site - what semiotic meaning can be pulled from colour, typography and layout? Will your user visit your site on a touchscreen device or PC?.</p>

<p>The more you know about your target demographic, the easier it is to design sites that make sense both navigationally and psychologically for the end user. UI comes down heavily to <a href="https://www.moshi.com.au/blog/understanding-consumer-behaviour"> consumer behaviour</a>, and any bias or previous experience they may have.</p> 

<h3>UX is the overall feel of the experience and path. UI is the actual interactivity, look and layout of the site.</h3>

<p>Both must work hand in hand for a website to function at its best potential. Your user should be able to enter the website and follow a clear path to <b>conversion</b>.</p>

<br></br><hr></hr>

<h2>Designing With Humans (and Goals) in Mind</h2>   

<h3>Determine Your Business Goals</h3>
<p>What are you bringing customers to your site to do? Join a mailing list, purchase a product, subscribe to a service or simply learn about your brand? You should also consider the <i>value</i> of a conversion on your site.</p>

<p> A one-off purchase might be worth $10, but a signed up customer with a personal login may come back multiple times and end up with a lifetime value of $500.</p>
<p>With your data researched, you may consider a sign up goal to be more valuable than a purchase goal, which in turn affects your entire user flow. It’s important to consider these data points before you begin nutting out the design and flow of your site. </p>

<img src={require('./image-2.jpg')} alt="An example of a User Flow Outline" height="300" width="650" className="align-centre" align="centre" />
<h5>Photo by Alvaro Reyes on Unsplash</h5> 
<br></br>

<h3>Flow Outline Considering Entry Points</h3>
<p>Before you even begin to think about the look of your site, you should create a <i>Flow Outline</i>, showing possible user routes and options available.</p>
<p>A Flow Outline is pretty much what it sounds like. Remember what a traffic funnel is? Well a Flow Outline is a clearly mapped out funnel. Consider the entry points for your site - (direct, social, organic, paid) and create a flow diagram for each, leading from entry point to conversion point. Eg: Someone looking directly for your site might be greeted with a sign in page straight away, and from there they can sign in, sign up or exit. Whereas someone coming from a <a href="https://www.moshi.com.au/whatwedo/social-media-marketing">Facebook targeted ad</a> may be greeted with a landing page more specific to the ad they clicked on.</p>



<p>As <a href="https://www.uxpin.com/studio/blog/creating-perfect-user-flows-for-smooth-ux/">UX Pin</a> describe, outlining the steps upon entry will help you to develop the style and look of the website as you continue.</p> 
<p>This is already considering the UX in your site. Your Flow Outline should take into account multiple pathways and options available to your user, whilst accounting for UI as well. The two are so intertwined it can become difficult to separate them sometimes!</p>
<br></br>
<h3>Creating Your WireFlow For Optimum Conversions</h3>


<img src={require('./image-3.png')} alt="An example of a User Flow Outline" height="300" width="650" className="align-centre" align="centre" />
<h5><a href="https://dribbble.com/pons">Simplified Checkout Process by Michael Pons</a></h5>
<br></br>

<p>A Wireflow is a modern term for web designers <a href="https://www.nngroup.com/articles/wireflows/">(created by NN Group)</a>
, being a hybrid of a traditional WireFrame (sitemap) and a Flow Chart (actions taken). </p>

<p>A Wireflow is a much more detailed representation of how your user will get from A to B. Both UI <i>and</i> UX factors are strongly in play here - you may have already added colours, font choices and layout options according to which technology is being used to access the site, you have considered mobile optimised and tablet-friendly versions, you have thought about consumer bias in placements and how they want to interact with your site.</p>

<img src={require('./image-4.png')} alt="Interactive Wireflows" height="400" width="650" className="align-centre" align="centre" />

<p>Keep in mind that the aim of your user journey is to keep them travelling through your sales funnel until they complete an action. With that in mind, map out your messaging appropriately as well. When is it relevant to show a Welcome message as opposed to a Welcome Back? Should you be suggesting additional items or pages to flow through to, or should you implement an ‘easy checkout’ option?</p>

<br></br><hr></hr>
<h2>Combine UX, UI and Research For a Highly Converting Website</h2>
<p>A successfully converting website does it research. The designer should know who they’re talking to and designing for at all times, the copywriter should be writing for the same person. For a consistent brand and a voice, take the time to create a <a href="https://www.moshi.com.au/blog/establishing-a-voice-for-your-brand">Purpose Chart</a></p>
<p>The initial research you undertake will save you an immense amount of time on edits, redesigns and restructures. If we can give you any advice when creating a new business, it will be this: <b>Do. Your. Premilimary. Research.</b> </p>

<p>If you are thinking of creating a website or an app, and have an end user in mind, <a href="https://www.moshi.com.au/contact-us">get in touch with our team</a>  today.</p> 


							




							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/UX/index.js